import { IPerformanceEvaluationType } from "models/PerformanceEvaluationTypeModel";
import { BaseService } from "./base.service";

class PerformanceEvaluationTypeServiceInternal extends BaseService {
	getPerformanceEvaluationTypeList = async (): Promise<
		IPerformanceEvaluationType[]
	> =>
		this.callApi<IPerformanceEvaluationType[]>(
			`PerformanceEvaluationType/GetAll`,
			"GET"
		);
}

export const PerformanceEvaluationTypeService =
	new PerformanceEvaluationTypeServiceInternal();
